import { GQLIdEncoder } from '../../../common/utils/GQLIdEncoder';
import { Host } from '../models/Host';

export class HostMapper {
  readonly gqlIdEncoder = new GQLIdEncoder();

  mapGQLModel(data: any): Host {
    const reportId = data.reportId ? this.gqlIdEncoder.decode(data.reportId) : null;
    return new Host(this.gqlIdEncoder.decode(data.id), data.name, data.status, data.platform, data.statusReason, data.originId, reportId);
  }
}
